export default {"src":"/_next/static/media/W.59780eb5.svg","height":18,"width":18};